import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Button } from '../ui/button';
import { ArrowRight, MessageCircle } from 'lucide-react';
import { fadeInUp, smoothTransition } from './animations';

const WHATSAPP_LINK = 'https://wa.me/523312949249?text=Quiero%20mi%20menú%20digital%20para%20mi%20negocio';

export const FinalCTA = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section ref={ref} className="py-20 sm:py-32 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-background via-muted/10 to-background" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-primary/10 rounded-full blur-3xl" />
      <div className="absolute top-1/2 right-1/4 w-[400px] h-[400px] bg-[hsl(var(--cta-orange))]/10 rounded-full blur-3xl" />
      
      <div className="container px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div
          {...fadeInUp}
          animate={inView ? fadeInUp.animate : fadeInUp.initial}
          transition={smoothTransition}
          className="max-w-4xl mx-auto text-center"
        >
          <div className="glass-card border border-primary/20 rounded-3xl p-8 sm:p-12 lg:p-16">
            <h2 className="text-3xl sm:text-4xl lg:text-6xl font-bold mb-6">
              Cada día que sigues usando tu menú actual{' '}
              <span className="text-destructive">estás perdiendo dinero</span>.
            </h2>
            
            <p className="text-xl sm:text-2xl text-muted-foreground mb-10">
              Empieza hoy a convertir cada cliente en más consumo.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Button
                size="lg"
                className="bg-gradient-to-r from-[hsl(var(--cta-orange))] to-[hsl(var(--cta-orange-hover))] text-white hover:shadow-[0_0_40px_hsl(var(--cta-orange)/0.5)] transition-all duration-300 text-lg px-10 py-7 rounded-xl group"
                onClick={() => window.open(WHATSAPP_LINK, '_blank')}
              >
                <MessageCircle className="w-5 h-5 mr-2" />
                Quiero mi menú que venda
                <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>
            
            <p className="text-sm text-muted-foreground mt-8">
              No necesitas experiencia, no necesitas cambiar tu operación y no necesitas complicarte.
              <br />
              Solo necesitas un mejor sistema para presentar lo que ya vendes.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
